import { AppointmentSlotScheduleQuery, AppointmentUpdateNoteCommand } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { translationKeys } from '../../translations';

import { AppointmentNoteFormBean } from './AppointmentNoteManagementForm';

type AppointmentNoteUpdateActionRenderProps = {
   updateAppointmentNote: (formData: AppointmentNoteFormBean) => Promise<void>;
};

type AppointmentNoteUpdateActionProps = {
   readonly appointmentId: number;
   readonly children: (renderProps: AppointmentNoteUpdateActionRenderProps) => JSX.Element;
   readonly onSuccess: VoidFunction;
};

export const AppointmentNoteUpdateAction = (props: AppointmentNoteUpdateActionProps): JSX.Element => {
   const { executeAsync: updateAppointmentNote } = useCqrsCommand<void, AppointmentNoteFormBean>(
      (parameters) => {
         const command = new AppointmentUpdateNoteCommand();
         command.id = AppointmentId.of(props.appointmentId);
         command.note = Choice.withUseDefaultIfNull(parameters.note);
         return command;
      },
      {
         onSuccess: (__, formData) => {
            props.onSuccess();
            refetchCqrsQuery(AppointmentSlotScheduleQuery);

            const snackbarText = formData.note
               ? translationKeys.noteManagement.update.action.successful.withContent
               : translationKeys.noteManagement.update.action.successful.withoutContent;

            dispatchSnackbarPositiveEvent(snackbarText);
         },
      }
   );

   return props.children({
      updateAppointmentNote: updateAppointmentNote,
   });
};
